import React from 'react';
import * as Styled from './styles';

const LiveIndicator = (): JSX.Element => {
  return <Styled.Indicator />;
};

export default LiveIndicator;
